export enum SaveMode {
  ADD = 'add',
  MODIFY = 'modify',
  COPY = 'copy'
}
